import { render, staticRenderFns } from "./EnderecoTable.vue?vue&type=template&id=039a2597"
import script from "./EnderecoTable.vue?vue&type=script&lang=js"
export * from "./EnderecoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports